(function () {
    'use strict';

    angular
        .module('app.layout')
        .controller('TitleController', TitleController);

    /* @ngInject */
    function TitleController(userProfileService) {
        var vm = this;
        vm.title = '';

        activate();

        function activate() {
            userProfileService.getUserProfile().then(function (profile) {
                if (profile.status === 200) {
                    vm.title = profile.data.Organization.Name +
                        ', ' + profile.data.Organization.Address1;                    
                }                
            });
        }
    }
})();
